const SEARCH = {
  // サジェスト表示上限
  suggestMaxResults: 5,
  // サジェストAPIのタイムアウト時間（ms）
  suggestTimeoutMs: 3000,
  // 履歴保持上限
  searchHistoryMaxItems: 10,
  // 検索結果上限
  searchMaxResults: 10,
  // キーワード最大長
  maxKeywordLength: 100,
  // 通知表示時間（ms）
  notificationHideDelayMs: 3000,

  // 主に日本語入力（IME）のオン状態で文字キーを押した際に発生する値
  // safariで日本語の決定とともに検索が走ってしまうことの対策に使用
  keyCodeImeComposition: 229,

  // 電話帳リンク用
  phonebook: {
    urlPartsPhonebook: 'phonebook',
    urlPartsAddress: 'address',
    urlPartsStation: 'station',
    // リンク遷移時、正しいものに自動で変換される。空白を埋めるために一時的に使用するコード
    tmpCategory2Code: 'M00000',
    tmpCityCode: '00000',
    cityCodeLength: 5,
    linkTarget: '_blank',
    linkRel: 'noopener noreferrer',
  },
  itemType: {
    station: 'station',
    gourmet: 'gourmet',
    majorSpot: 'major_spot',
    address: 'address',
    pref: 'pref',
    city: 'city',
    zip: 'zip',
  },

  // サジェストのデバウンス待機時間（ms）
  suggestDebounceMs: 1000,

  // place検索プレフィックス
  placePrefix: 'place',
  // 検索クエリパラメータ名
  queryParam: 'q',
  // POIコード検索パラメータ名
  poiParam: 'poi',
  // マイスポット検索パラメータ名
  mySpotParam: 'myspot',
  // 履歴パラメータ名
  historyParam: 'history',

  endPointName: {
    suggest: 'suggest',
    search: 'search',
  },

  // station
  station: {
    unknownStationName: '駅名不明',
    categoryTypeStation: 'station',
    categoryTypeStationJp: '駅',
    defaultRadiusMeters: 300000,
    maxRadiusMeters: 500000
  },

  messages:{
    noResults: '検索結果が見つかりませんでした',
  }
};

export default SEARCH;
